export const hasTeamAccess = (user, team) =>
  user?.superAdmin === true ||
  (user?.accessLevel === "admin" &&
    (user.roles || []).some((entry) => entry.team === team));

// A team's leadership: an admin who is head or mentor OF THAT TEAM, or a
// superAdmin. Mirrors isTeamLeader in the API's app/services/permissions.js.
export const isTeamLeader = (user, team) =>
  user?.superAdmin === true ||
  (user?.accessLevel === "admin" &&
    (user.roles || []).some(
      (entry) =>
        entry.team === team &&
        (entry.roles || []).some((role) => role === "mentor" || role === "head")
    ));

export const canManageUsers = (user) =>
  user?.superAdmin === true ||
  (user?.accessLevel === "admin" &&
    (user.roles || []).some((entry) =>
      (entry.roles || []).some((role) => role === "mentor" || role === "head")
    ));
